/* towsons-share.js — Share & save (snippets/towsons-share; lib/storefront/shareReward in the portal).
 *
 * Philip, 7 Oct 2026: "make the experience of sharing a public social post into more of a game … reward the visitor
 * a 5% off code if they publicly share what ever page they are on".
 *
 * Nobody can read another person's feed. By default (the shop's unlock 'share' — Philip, once it was live: "maybe we
 * should just ask the user to share a post publicly and then show a code") sharing is enough: two steps, 1 share your
 * link, 2 your code — it comes a few seconds after they have shared (the edge unlocks it, the portal makes it). The
 * stricter way (unlock 'open') is the proof a page can have, the visitor's own link opened by somebody else: three
 * steps, 1 share your link, 2 a friend opens it, 3 your code.
 *   - "Share & get 5% off" (a floating button, and a card on product and blog pages) opens the panel and asks the
 *     shop's own data address for a link to this page: POST <edge>/v1/share → { ref, link } (?sh=<ref> on the page).
 *   - Each network's button opens that network with the link and the shop's words — honest words: the message says
 *     the sharer gets a discount for it. The edge is told which (POST …/<ref>/sent), for the portal's counts.
 *   - A page opened from a link with ?sh= tells the edge (POST …/<ref>/open) and takes the ?sh= off its address.
 *     Nothing is kept on that visitor's device.
 *   - The sharer's links are remembered on their device (localStorage: a random device id and up to 5 links), and
 *     asked after (GET …/<ref>?d=<device>) — the edge hands a code only to the device that made the link.
 * The code is THIS MONTH'S — the same for every sharer, taken once per customer at the checkout (Philip, 7 Oct 2026: "we
 * always just show the same code (changes each month) and restrict one use to each customer"): the edge answers the
 * share with it, so it shows at once, and nobody is told they had one already.
 * The code appears with "Use it now" — Shopify's own /discount/<code> address puts it on the basket.
 * Where the theme had its own share icons (Warehouse's product and blog-post rows), the card takes their place — the
 * snippet hides them while this shows (Philip: "it overlaps the old social sharing stuff that needs removing").
 */
(function () {
  'use strict';
  if (window.__twShare) return;
  window.__twShare = true;
  var me = document.currentScript || document.querySelector('script[data-tw-share]');
  if (!me) return;
  var d = me.dataset || {};
  var EDGE = String(d.edge || '').replace(/\/+$/, '');
  if (!/^https:\/\//.test(EDGE)) return;
  var cfg = {};
  try { cfg = JSON.parse(d.config || '{}') || {}; } catch (e) { cfg = {}; }
  if (!cfg.on) return;
  var REF = /^[A-Za-z0-9]{6,16}$/;
  var PAGE = { kind: d.kind || 'page', noun: d.noun || 'page', title: d.title || document.title, url: d.url || location.href.split('#')[0], image: d.image || '', shop: d.shop || '' };
  var PCT = Number(cfg.percent) || 5;
  var NEEDED = Math.max(1, Number(cfg.opens_needed) || 1);
  var MODE = cfg.unlock === 'open' ? 'open' : 'share';   // 'share': shared is enough; 'open': a friend must open it
  var NETS = Array.isArray(cfg.networks) && cfg.networks.length ? cfg.networks : ['facebook', 'x', 'bluesky', 'threads', 'pinterest', 'linkedin'];
  var STORE_KEY = 'tw_share';
  var DEVICE_KEY = 'tw_share_device';

  // ── storage (a private window, or storage switched off, still plays: it just forgets on the next page) ──
  var mem = {};
  function readStore() {
    try { var v = JSON.parse(localStorage.getItem(STORE_KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return mem[STORE_KEY] || []; }
  }
  function writeStore(list) {
    var v = (list || []).slice(0, 5);
    mem[STORE_KEY] = v;
    try { localStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (e) { /* kept for this page only */ }
  }
  function device() {
    var v = null;
    try { v = localStorage.getItem(DEVICE_KEY); } catch (e) { v = mem[DEVICE_KEY] || null; }
    if (v && /^[A-Za-z0-9]{20,40}$/.test(v)) return v;
    var a = new Uint8Array(24);   // the edge takes 20 to 40 (SHARE_DEVICE)
    (window.crypto || window.msCrypto).getRandomValues(a);
    var abc = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    v = '';
    for (var i = 0; i < a.length; i++) v += abc[a[i] % abc.length];
    mem[DEVICE_KEY] = v;
    try { localStorage.setItem(DEVICE_KEY, v); } catch (e) { /* this page only */ }
    return v;
  }
  function samePage(a, b) {
    try { var x = new URL(a), y = new URL(b); return x.host === y.host && x.pathname.replace(/\/+$/, '') === y.pathname.replace(/\/+$/, ''); } catch (e) { return false; }
  }
  function linkForPage() {
    return readStore().filter(function (l) { return l && samePage(l.url, PAGE.url) && !l.gone; })[0] || null;
  }
  function remember(l) {
    var list = readStore().filter(function (x) { return x && x.ref !== l.ref; });
    list.unshift(l);
    writeStore(list);
  }
  function update(ref, patch) {
    writeStore(readStore().map(function (x) { return x && x.ref === ref ? Object.assign({}, x, patch) : x; }));
  }

  // ── the edge ──
  function post(path, body) {
    return fetch(EDGE + path, { method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { j.__status = r.status; return j; }); });
  }
  function get(path) {
    return fetch(EDGE + path, { method: 'GET', mode: 'cors', credentials: 'omit' }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  // ── somebody opened a shared link: say so, and take ?sh= off the address ──
  (function opened() {
    var u;
    try { u = new URL(location.href); } catch (e) { return; }
    var ref = u.searchParams.get('sh');
    if (!ref) return;
    u.searchParams.delete('sh');
    try { history.replaceState(history.state, '', u.pathname + (u.search ? u.search : '') + u.hash); } catch (e) { /* the address keeps it */ }
    if (!REF.test(ref)) return;
    if (readStore().some(function (l) { return l && l.ref === ref; })) return;   // their own link, opened by them
    post('/v1/share/' + ref + '/open', {}).catch(function () { /* a missed open is a missed open */ });
  })();

  // ── words ──
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function pctText() { return (Math.round(PCT * 10) / 10) + '%'; }
  function label() { return cfg.label || ('Share & get ' + pctText() + ' off'); }
  function message() {
    var t = String(cfg.text || 'Look what I found on {shop}').replace(/\{shop\}/g, PAGE.shop).replace(/\{title\}/g, PAGE.title);
    var honest = String(cfg.honest || '').replace(/\{percent\}/g, String(PCT));
    return PAGE.title && t.indexOf(PAGE.title) < 0 ? t + ': ' + PAGE.title + (honest ? ' (' + honest + ')' : '') : t + (honest ? ' (' + honest + ')' : '');
  }
  // The public places first, as the portal lists them (lib/storefront/shareReward NETWORKS); drawn in this order.
  var NET = {
    facebook: { label: 'Facebook', bg: '#1877F2', glyph: 'f', href: function (l) { return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(l); } },
    x: { label: 'X', bg: '#000', glyph: 'X', href: function (l) { return 'https://x.com/intent/post?text=' + encodeURIComponent(message()) + '&url=' + encodeURIComponent(l); } },
    bluesky: { label: 'Bluesky', bg: '#1185FE', glyph: 'b', href: function (l) { return 'https://bsky.app/intent/compose?text=' + encodeURIComponent(message() + ' ' + l); } },
    threads: { label: 'Threads', bg: '#111', glyph: '@', href: function (l) { return 'https://www.threads.net/intent/post?text=' + encodeURIComponent(message() + ' ' + l); } },
    pinterest: { label: 'Pinterest', bg: '#E60023', glyph: 'P', href: function (l) { return 'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(l) + (PAGE.image ? '&media=' + encodeURIComponent(PAGE.image) : '') + '&description=' + encodeURIComponent(message()); } },
    linkedin: { label: 'LinkedIn', bg: '#0A66C2', glyph: 'in', href: function (l) { return 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(l); } },
    reddit: { label: 'Reddit', bg: '#FF4500', glyph: 'r', href: function (l) { return 'https://www.reddit.com/submit?url=' + encodeURIComponent(l) + '&title=' + encodeURIComponent(PAGE.title || message()); } },
    tumblr: { label: 'Tumblr', bg: '#36465D', glyph: 't', href: function (l) { return 'https://www.tumblr.com/widgets/share/tool?posttype=link&canonicalUrl=' + encodeURIComponent(l) + '&title=' + encodeURIComponent(PAGE.title) + '&caption=' + encodeURIComponent(message()); } },
    whatsapp: { label: 'WhatsApp', bg: '#25D366', glyph: 'W', href: function (l) { return 'https://wa.me/?text=' + encodeURIComponent(message() + '\n' + l); } },
    email: { label: 'Email', bg: '#6b7280', glyph: '✉', href: function (l) { return 'mailto:?subject=' + encodeURIComponent(PAGE.title) + '&body=' + encodeURIComponent(message() + '\n\n' + l); } },
    copy: { label: 'Copy link', bg: '#374151', glyph: '⧉', href: null },
  };

  // ── the visitor's code: this month's, the same on every page — and whether Shopify has it on the basket ──
  // Philip, 7 Oct 2026: "when the code is made and shown to customer, make sure the other messaging shows this popup and
  // if user click use now then make sure all messaging says applied to basket". The button, the line and the panel all
  // say the same: ready (tap to see it) or applied. Applied is Shopify's own word — its /discount/<code> address sets
  // the discount_code cookie (SameSite=Lax, readable). A code past its month (`until`) is no longer anyone's.
  function appliedCode() {
    var m = /(?:^|;\s*)discount_code=([^;]*)/.exec(document.cookie || '');
    if (!m) return '';
    try { return decodeURIComponent(m[1]).toUpperCase(); } catch (e) { return String(m[1]).toUpperCase(); }
  }
  function myCode() {
    var now = Date.now();
    return readStore().filter(function (x) { return x && x.code && (!x.until || x.until > now); })
      .sort(function (a, b) { return (b.got || b.made || 0) - (a.got || a.made || 0); })[0] || null;
  }
  function isApplied(l) { return !!(l && l.code && appliedCode() === String(l.code).toUpperCase()); }
  function cartUrl() { return (window.routes && window.routes.cartUrl) || '/cart'; }

  // ── the button(s) ──
  var pill = null;
  function mountPill() {
    if (pill || document.querySelector('.tw-sh-pill')) return;
    pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'tw-sh tw-sh-pill tw-mod';
    pill.setAttribute('aria-haspopup', 'dialog');
    pill.innerHTML = '<span class="tw-sh-pill__gift" aria-hidden="true">🎁</span><span class="tw-sh-pill__label"></span>';
    pill.addEventListener('click', function () { open(); });
    document.body.appendChild(pill);
    paintPill();
  }
  function paintPill() {
    if (!pill) return;
    var mine = myCode();
    var applied = isApplied(mine);
    var waiting = !mine && readStore().filter(function (l) { return l && l.sent && !l.code && !l.refused && (MODE === 'share' || (l.opens || 0) < NEEDED); })[0];
    pill.classList.toggle('is-ready', !!mine);
    pill.classList.toggle('is-applied', applied);
    paintInline();
    pill.querySelector('.tw-sh-pill__gift').textContent = applied ? '✓' : '🎁';
    pill.querySelector('.tw-sh-pill__label').textContent = applied ? pctText() + ' off applied to your basket' : (mine ? 'Your ' + pctText() + ' code is ready' : (waiting ? (MODE === 'share' ? 'Making your code…' : 'Waiting for a friend…') : label()));
  }
  // A card in the place of the theme's own share icons (the snippet hides them while this shows): on a product page
  // where its share row was, else at the end of its title block; on a blog post at the end of the post.
  var SPOTS = {
    product: ['.product-meta__share-buttons', '.product__share', '.tw-sh-spot', '.product-meta', '.product__info-container', '.product__info'],
    article: ['.article__content', '.article-template__content', 'article .rte'],
  };
  // CONDENSED, OPENING TO EXPLAIN (Philip, 7 Oct 2026: "make the share bit up the top more condensed with something
  // like 'Want to save 5% on this mug?' When user clicks it opens up and explains"): one line; a tap opens how it
  // works and the button that starts it. A code already waiting turns the line into "Your 5% code is ready", which
  // opens it.
  function question() {
    return PAGE.kind === 'product' ? 'Want to save ' + pctText() + ' on this ' + PAGE.noun + '?' : 'Want ' + pctText() + ' off? Share this ' + PAGE.noun;
  }
  function explain() {
    var where = 'Share this ' + PAGE.noun + ' with your friends — on WhatsApp, Facebook, by email, anywhere. ';
    var when = MODE === 'share' ? 'As soon as you have, this month’s ' + pctText() + ' code appears' : 'When one of them opens your link, this month’s ' + pctText() + ' code appears';
    return where + when + ' — use it once, on any order.';
  }
  var inline = null;
  function paintInline() {
    if (!inline) return;
    var mine = myCode();
    var applied = isApplied(mine);
    inline.classList.toggle('is-ready', !!mine);
    inline.classList.toggle('is-applied', applied);
    inline.querySelector('.tw-sh-inline__ask').textContent = applied ? pctText() + ' off applied to your basket — ' + mine.code : (mine ? 'Your ' + pctText() + ' code is ready — tap to see it' : question());
    inline.querySelector('.tw-sh-inline__gift').textContent = applied ? '✅' : (mine ? '🎉' : '🎁');
  }
  function mountInline() {
    var list = SPOTS[PAGE.kind];
    if (!list || document.querySelector('.tw-sh-inline')) return;
    var spot = null;
    for (var i = 0; i < list.length && !spot; i++) spot = document.querySelector(list[i]);   // in order of preference, not of the page
    if (!spot) return;
    var b = document.createElement('div');
    b.className = 'tw-sh tw-sh-inline tw-mod';
    var id = 'tw-sh-more-' + Math.random().toString(36).slice(2, 8);
    b.innerHTML = '<button type="button" class="tw-sh-inline__q" aria-expanded="false" aria-controls="' + id + '"><span class="tw-sh-inline__gift" aria-hidden="true">🎁</span><span class="tw-sh-inline__ask"></span><span class="tw-sh-inline__chev" aria-hidden="true"></span></button>'
      + '<div class="tw-sh-inline__more" id="' + id + '" hidden><p class="tw-sh-inline__how"></p><button type="button" class="tw-sh-inline__go"></button></div>';
    b.querySelector('.tw-sh-inline__how').textContent = explain();
    b.querySelector('.tw-sh-inline__go').textContent = 'Share & get my ' + pctText() + ' code';
    var q = b.querySelector('.tw-sh-inline__q'), more = b.querySelector('.tw-sh-inline__more');
    q.addEventListener('click', function () {
      if (b.classList.contains('is-ready')) { open(); return; }
      var shown = q.getAttribute('aria-expanded') !== 'true';
      q.setAttribute('aria-expanded', String(shown));
      more.hidden = !shown;
      b.classList.toggle('is-open', shown);
    });
    b.querySelector('.tw-sh-inline__go').addEventListener('click', function () { open(); });
    inline = b;
    paintInline();
    // The theme's share row: the card goes where it was. A container (title block, the post): the card goes at its end.
    if (/share/.test(spot.className)) spot.parentNode.insertBefore(b, spot);
    else if (PAGE.kind === 'article') spot.parentNode.insertBefore(b, spot.nextSibling);
    else spot.appendChild(b);
  }

  // ── the panel ──
  var back = null, box = null, lastFocus = null, timer = null, current = null;
  function close() {
    if (!back) return;
    back.remove(); back = null; box = null;
    if (timer) { clearInterval(timer); timer = null; }
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) { /* gone */ } }
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  function open() {
    if (back) return;
    lastFocus = document.activeElement;
    back = document.createElement('div');
    back.className = 'tw-sh tw-sh-back';
    back.addEventListener('click', function (e) { if (e.target === back) close(); });
    box = document.createElement('div');
    box.className = 'tw-sh-box';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-labelledby', 'tw-sh-h');
    back.appendChild(box);
    document.body.appendChild(back);
    document.addEventListener('keydown', onKey);
    // A code already earned (on any page — it is this month's, the same everywhere) is what the panel shows.
    current = myCode() || linkForPage();
    paint();
    if (!current) make();
    else if (!current.code) check(current);
    timer = setInterval(function () { if (current && !current.code) check(current); }, 15000);
    var x = box.querySelector('.tw-sh-x');
    if (x) x.focus();
  }
  function steps(l) {
    var sent = !!(l && l.sent), opened = !!(l && ((l.opens || 0) >= NEEDED || l.code)), got = !!(l && l.code);
    var cls = function (done, now) { return 'tw-sh-step' + (done ? ' is-done' : (now ? ' is-now' : '')); };
    if (MODE === 'share') {
      return '<ol class="tw-sh-steps tw-sh-steps--two">'
        + '<li class="' + cls(sent, !sent) + '"><b>' + (sent ? '✓' : '1') + '</b>Share your link</li>'
        + '<li class="' + cls(got, sent && !got) + '"><b>' + (got ? '🎉' : '2') + '</b>Your ' + esc(pctText()) + ' code</li>'
        + '</ol>';
    }
    return '<ol class="tw-sh-steps">'
      + '<li class="' + cls(sent, !sent) + '"><b>' + (sent ? '✓' : '1') + '</b>Share your link</li>'
      + '<li class="' + cls(opened, sent && !opened) + '"><b>' + (opened ? '✓' : '2') + '</b>' + (NEEDED > 1 ? NEEDED + ' friends open it' : 'A friend opens it') + (l && !opened && (l.opens || 0) ? ' (' + l.opens + '/' + NEEDED + ')' : '') + '</li>'
      + '<li class="' + cls(got, opened && !got) + '"><b>' + (got ? '🎉' : '3') + '</b>Your ' + esc(pctText()) + ' code</li>'
      + '</ol>';
  }
  function paint(msg, warn) {
    if (!box) return;
    var l = current;
    var applied = isApplied(l);
    var h = '<button type="button" class="tw-sh-x" aria-label="Close">×</button>'
      + '<h2 class="tw-sh-h" id="tw-sh-h">' + (l && l.code ? (applied ? 'Applied to your basket ✓' : 'You did it! 🎉') : esc(label())) + '</h2>';
    // The code: on its own — the steps that led here are done with ("no need to show the bottom two boxes").
    if (l && l.code && applied) {
      h += '<p class="tw-sh-sub">' + esc(l.value_text || (pctText() + ' off')) + ' comes off at the checkout — your code is on your basket' + (l.expires_text ? ' until ' + esc(l.expires_text) : '') + '.</p>'
        + '<div class="tw-sh-code is-applied">✓ Applied<span class="tw-sh-code__c">' + esc(l.code) + '</span>'
        + '<a class="tw-sh-btn tw-sh-btn--go" href="' + esc(cartUrl()) + '">Go to your basket</a>'
        + '<button type="button" class="tw-sh-btn" data-sh-copy-code>Copy code</button></div>';
    } else if (l && l.code) {
      h += '<p class="tw-sh-sub">Thanks for sharing. Here is your code — it works once, on anything in the shop' + (l.expires_text ? ', until ' + esc(l.expires_text) : '') + '.</p>'
        + '<div class="tw-sh-code">' + esc(l.value_text || (pctText() + ' off')) + '<span class="tw-sh-code__c">' + esc(l.code) + '</span>'
        + '<button type="button" class="tw-sh-btn" data-sh-copy-code>Copy code</button>'
        + '<a class="tw-sh-btn tw-sh-btn--go" href="/discount/' + encodeURIComponent(l.code) + '?redirect=' + encodeURIComponent(location.pathname) + '">Use it now</a></div>';
    } else {
      h += '<p class="tw-sh-sub">Share this ' + esc(PAGE.noun) + ' anywhere you like. '
        + (MODE === 'share' ? 'As soon as you have, your ' + esc(pctText()) + ' code appears right here.' : 'When a friend opens your link, your ' + esc(pctText()) + ' code appears right here.') + '</p>'
        + steps(l);
      if (msg) h += '<p class="tw-sh-msg' + (warn ? ' is-warn' : '') + '">' + esc(msg) + '</p>';
      else if (l && l.refused) h += '<p class="tw-sh-msg is-warn">' + esc(l.refused) + '</p>';
      else if (l && (l.pending || (MODE === 'share' && l.sent))) h += '<p class="tw-sh-msg">Thanks for sharing! Your code is on its way — it appears here in a moment.</p>';
      if (l && l.link) {
        h += '<div class="tw-sh-nets">';
        // In the order the theme keeps (the public places first), whatever order the shop's list is in.
        Object.keys(NET).forEach(function (k) {
          var n = NET[k];
          if (NETS.indexOf(k) < 0 || (k === 'pinterest' && !PAGE.image)) return;
          h += n.href
            ? '<a class="tw-sh-net" data-sh-net="' + k + '" href="' + esc(n.href(l.link)) + '" target="_blank" rel="noopener"><i style="background:' + n.bg + '">' + n.glyph + '</i>' + esc(n.label) + '</a>'
            : '<button type="button" class="tw-sh-net" data-sh-net="' + k + '"><i style="background:' + n.bg + '">' + n.glyph + '</i>' + esc(n.label) + '</button>';
        });
        if (navigator.share && NETS.indexOf('native') >= 0) h += '<button type="button" class="tw-sh-net" data-sh-net="native"><i style="background:#e8532b">⋯</i>More…</button>';
        h += '</div>';
        // The link to copy, only when the shop lets it be copied (a post on a public network is what it wants seen).
        if (NETS.indexOf('copy') >= 0) h += '<div class="tw-sh-link"><input type="text" readonly value="' + esc(l.link) + '" aria-label="Your link"><button type="button" class="tw-sh-btn" data-sh-net="copy">Copy</button></div>';
      } else if (!msg) {
        h += '<p class="tw-sh-msg">Making your link…</p>';
      }
      h += '<p class="tw-sh-note">This month’s code works once for each customer. Your message says you get a discount for sharing — that keeps it honest.</p>';
    }
    box.innerHTML = h;
    box.querySelector('.tw-sh-x').addEventListener('click', close);
    Array.prototype.forEach.call(box.querySelectorAll('[data-sh-net]'), function (el) {
      el.addEventListener('click', function (e) { shareVia(el.getAttribute('data-sh-net'), e); });
    });
    var cc = box.querySelector('[data-sh-copy-code]');
    if (cc) cc.addEventListener('click', function () { copy(current.code, cc, 'Copied!'); });
    var used = box.querySelector('.tw-sh-btn--go');
    if (used) used.addEventListener('click', function () { update(current.ref, { used: true }); });
    paintPill();
  }
  function copy(text, el, done) {
    var ok = function () { if (el) { var was = el.textContent; el.textContent = done || 'Copied!'; setTimeout(function () { el.textContent = was; }, 1600); } };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(ok, function () { fallbackCopy(text); ok(); });
    else { fallbackCopy(text); ok(); }
  }
  function fallbackCopy(text) {
    var t = document.createElement('textarea'); t.value = text; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
    document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e) { /* the field shows it */ } t.remove();
  }
  function shareVia(k, e) {
    var l = current;
    if (!l || !l.link) return;
    if (k === 'copy') { copy(l.link, e && e.currentTarget && e.currentTarget.tagName === 'BUTTON' ? e.currentTarget : null, 'Copied!'); }
    if (k === 'native') {
      e.preventDefault();
      navigator.share({ title: PAGE.title, text: message(), url: l.link }).then(function () { sent(l, 'native'); }, function () { /* they changed their mind */ });
      return;
    }
    sent(l, k);
  }
  // Where they shared it, said to the edge. The default way, that is what earns the code: the edge says whether it
  // unlocked (or why not), and the code is asked after every few seconds until it comes (the portal makes it).
  var quick = null;
  function sent(l, via) {
    var first = !l.sent;
    current = Object.assign({}, l, { sent: true });
    update(l.ref, { sent: true });
    post('/v1/share/' + l.ref + '/sent', { d: device(), via: via }).then(function (j) {
      if (!j || j.ok === false) return;
      var patch = { limited: false, blocked: false };
      if (j.code) Object.assign(patch, { code: j.code, value_text: j.value_text || null, expires_text: j.expires_text || null, until: Number(j.until) || null, got: Date.now(), pending: false });
      else if (j.unlocked) patch.pending = !l.code;
      update(l.ref, patch);
      if (current && current.ref === l.ref) current = Object.assign({}, current, patch);
      if (j.unlocked && !j.code) soon(l);
      if (box) paint(); else paintPill();
    }, function () { /* counted or not, the link works */ });
    if (first) setTimeout(function () { paint(); }, 400);
  }
  function soon(l) {
    if (quick) clearInterval(quick);
    var tries = 0;
    quick = setInterval(function () {
      var now = readStore().filter(function (x) { return x && x.ref === l.ref; })[0];
      if (++tries > 40 || !now || now.code || now.refused) { clearInterval(quick); quick = null; return; }
      check(now);
    }, 3000);
  }
  function make() {
    post('/v1/share', { page: PAGE.url, title: PAGE.title, kind: PAGE.kind, d: device() }).then(function (j) {
      if (!j || !j.ok || !REF.test(String(j.ref || ''))) {
        paint(j && j.__status === 429 ? 'Too many just now — try again in a minute.' : ((j && j.message) || 'We couldn’t make your link just now — try again in a moment.'), true);
        return;
      }
      current = { ref: j.ref, link: j.link, url: PAGE.url, title: PAGE.title, made: Date.now(), opens: 0 };
      remember(current);
      paint();
    }, function () { paint('We couldn’t make your link just now — check your connection and try again.', true); });
  }
  function check(l) {
    if (!l || !REF.test(String(l.ref || ''))) return;
    get('/v1/share/' + l.ref + '?d=' + encodeURIComponent(device())).then(function (j) {
      if (!j || j.ok === false) {
        if (j && j.gone) { update(l.ref, { gone: true }); if (current && current.ref === l.ref) { current = null; if (box) make(); } }
        return;
      }
      var patch = { opens: Number(j.opens) || 0, limited: false, pending: !!j.pending, blocked: false };
      if (j.code) Object.assign(patch, { code: j.code, value_text: j.value_text || null, expires_text: j.expires_text || null, until: Number(j.until) || null, got: l.got || Date.now(), pending: false });
      if (j.refused) patch.refused = j.message || 'Sorry — no code this time.';
      update(l.ref, patch);
      var wasCode = l.code;
      if (current && current.ref === l.ref) current = Object.assign({}, current, patch);
      if (box && current && current.ref === l.ref) paint();
      else paintPill();
      if (!wasCode && patch.code && !box) paintPill();
    }, function () { /* asked again later */ });
  }
  // Links still waiting, asked after once when the page opens and when the visitor comes back to the tab.
  function checkAll() {
    readStore().forEach(function (l) { if (l && !l.code && !l.gone && !l.refused && Date.now() - (l.made || 0) < 30 * 86400000) check(l); });
  }

  function start() {
    mountPill();
    mountInline();
    checkAll();
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') checkAll(); });
  }
  if (typeof module === 'object' && module && module.exports) module.exports = { message: message, NET: NET };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
